import { render, staticRenderFns } from "./IndividualContractor.vue?vue&type=template&id=3cc99a59&scoped=true&"
import script from "./IndividualContractor.vue?vue&type=script&lang=ts&"
export * from "./IndividualContractor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc99a59",
  null
  
)

export default component.exports